module.exports = "./img/bad2e79b6deea770e6031085a523a0a9.png";